import { url_login } from "./constant/constant";

const authProvider = {
    // authentication
    login: ({ username, password }) =>  {
        const request = new Request(url_login, {
            method: 'POST',
            body: JSON.stringify({ username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });
        return fetch(request)
            .then(response => {
                if ((response.status < 200 || response.status >= 300) && response.status!=401 ) {
                    // console.log(response);
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then(auth => {
                if(auth.error){
                    throw new Error(auth.error);
                }
                localStorage.setItem('antrian-auth', JSON.stringify(auth));
            })
            .catch((error) => {
                throw new Error(error);
                // console.log(error);
                // console.log(error.json);
                // console.log(error.body);
                // console.log(error.json());
                // console.log(error.body());

                // error.then((value) => {
                //     console.log(value);
                //     throw new Error(value);
                //     // expected output: Incorrect username or password
                // });
            });
    },
    checkError: ({ status }) => {
        if (status === 401 || status === 403) {
            localStorage.removeItem('antrian-auth');
            return Promise.reject();
        }
        return Promise.resolve();
    },
    checkAuth: () => {
        return localStorage.getItem('antrian-auth')
            ? Promise.resolve()
            : Promise.reject();
    },
    logout: () => {
        localStorage.removeItem('antrian-auth');
        return Promise.resolve();
    },
    // getIdentity: () => Promise.resolve(/* ... */),
    // authorization
    // getPermissions: () => Promise.resolve(/* ... */),
    getPermissions: () => Promise.resolve(),
};

export default authProvider;